module.exports = __webpack_public_path__ + "img/head_bg2.93c0fd20.gif";